import React from 'react';
import ReactDOM from 'react-dom';
import CallProcessor from './CallProcessor';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

class AdminScoringTool extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `<div id="root"></div>`;
    ReactDOM.render(React.createElement(AdminScoringComponent), this.querySelector('#root'));
  }
}

customElements.define('admin-scoring-tool', AdminScoringTool);

const queryClient = new QueryClient();

function AdminScoringComponent() {
  const [callId, setCallId] = React.useState('');

  return (
    <QueryClientProvider client={queryClient}>
      <div className='report-details-container'>
        <h3>Admin Scoring Tool</h3>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            const callId = event.target['call-id'].value;
            setCallId(callId);
          }}
        >
          <div className='form-group' style={{ marginBottom: 15 }}>
            <label htmlFor='call-id'>Search by Call ID</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                style={{ width: 288 }}
                type='text'
                className='form-control'
                id='call-id'
                name='call-id'
              />
              <button type='submit' style={{ marginLeft: 6 }} className='btn btn-primary'>
                Search
              </button>
            </div>
          </div>
        </form>
        {callId ? <CallProcessor callId={callId} /> : null}
      </div>
    </QueryClientProvider>
  );
}
